import PillarForm from "shared/components/pillar-form/PillarForm";
import { useHubCheckoutInvoiceItemContext } from "hub/src/pages/checkout/context/HubCheckoutInvoiceItemContext";

export const HubCheckoutDiscountCode = () => {
  const { invoiceItem, openDiscountCodeModal } =
    useHubCheckoutInvoiceItemContext();

  return (
    <div
      className="flex pt-1"
      data-testid={`order-summary-discount-code-wrapper-${invoiceItem.invoiceItemId}`}
    >
      <div className="pt-1">
        {(invoiceItem.discount?.length ?? 0 > 0) ? (
          <div className="pr-2">Discount code applied</div>
        ) : null}
      </div>
      <PillarForm.Button
        testid={`order-summary-apply-discount-code-button-${invoiceItem.invoiceItemId}`}
        className="button-small-neutral-filled"
        onClick={() => openDiscountCodeModal(invoiceItem)}
      >
        Apply Discount Code
      </PillarForm.Button>
    </div>
  );
};
